import { makeStyles } from '@material-ui/core/styles';

export const styles = makeStyles((theme) => ({
    dialogContent: {
        marginTop: '32px !important',
        textAlign: 'center !important',
    },
}));
